module.exports = __webpack_public_path__ + "img/tuurro.inside.t.17baab5c.png";